var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logo)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.logo,"alt":_vm.alt}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }